import { useEffect } from 'react';

function IconFont() {
  useEffect(() => {
    const style = document.createElement('style');
    style.innerHTML = `
      @font-face {
        font-family: 'fontello';
        src: url("./fonts/fontello.woff") format("woff"),
          url("./fonts/fontello.woff2") format("woff2");
        font-weight: normal;
        font-style: normal;
      }
    `;
    document.head.appendChild(style);
  }, []);

  return null;
}

export default IconFont;
